import React, { useCallback, useEffect, useState } from 'react';
import { Modal, Row, Col, Form, InputGroup, Card, Badge, Button, Tab, Tabs } from 'react-bootstrap';
import { toast } from 'react-toastify';
import { useForm } from 'react-hook-form';
import { HttpStatus, SelectListItem } from 'modules/core';
import { getCityListByStateId } from 'modules/directory/city-master/services/city-master.service';
import { getAllCountryForSelect } from 'modules/directory/country-master/services/country-master.service';
import { getStateByCountryId } from 'modules/directory/state-master/services/state-master.service';
import { CustomerFormModel } from '../models/customer-form-model';
import { AddAllCustomerData, AddCustomerData } from '../../services';
import notistack from 'modules/core/notistack';
import { getCustomerByMobileNo, updateCustomer } from 'modules/customer/services';
import { useSelector } from 'react-redux';
import { RootState } from 'slices/app/store/store';
import ShippingAddressModal from './AddressForm';
import { getAllWalkInSourceForSelect } from 'modules/master/walk-in-source/services';

interface Customer {
    id: number;
    firstName: string;
    lastName: string;
    mobileNo: string;
    email?: string;
    address?: string;
    country?: string;
    state?: string;
    city?: string;
    zipCode?: string;
    prefix?: string;
    anniversaryDate?: string;
    birthdayDate?: string;
    engagementDate?: string;
    partnerName?: string;
    partnerContactNo?: string;
    partnerBirthdayDate?: string;
    gender?: string;
    altMobileNo?: string;
    gstNo?: string;
    panCardNo?: string;
    createdOn?: string;
    countryId?: number;
    stateId?: number;
    cityId?: number;
    zipcode?: string;
    anniversary?: string;
    birthday?: string;
    engagement?: string;
    spouseName?: string;
    spouseContactNo?: string;
    spouseBirthday?: string;
    walkInSourceId?: string | any;
}

interface AddCustomerProps {
    show: boolean;
    closeModal: () => void;
    handleCustomerClick: (data: any) => any;
    customerData?: any;
    setBillingAddressId?: any;
    setSelectedBilling?: any;
    selectedBilling?: any
}

const AddCustomer: React.FC<AddCustomerProps> = ({ show, closeModal, handleCustomerClick, customerData, setBillingAddressId, setSelectedBilling, selectedBilling }) => {
    const [loading, setLoading] = useState(false);
    const [stateList, setStateList] = useState<SelectListItem[]>([]);
    const [cityList, setCityList] = useState<SelectListItem[]>([]);
    const [countryDataList, setCountryData] = useState<SelectListItem[]>([]);
    const [customers, setCustomers] = useState<Customer[]>([]);
    const [filteredCustomers, setFilteredCustomers] = useState<Customer[]>([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [showCustomers, setShowCustomers] = useState(8);
    const [selectedCustomer, setSelectedCustomer] = useState<Customer | null>(null);
    const [showCustomersList, setShowCustomersList] = useState(false);
    const [walkInSources, setWalkInSources] = useState<SelectListItem[]>([])
    const [selectedShippingId, setSelectedShippingId] = useState()

    const [newCustomerForm, setNewCustomerForm] = useState<any>([])

    const [activeTab, setActiveTab] = useState("customer");
    const user = useSelector((state: RootState) => state?.Login?.user);

    const { register, watch, handleSubmit, setValue, setFocus, reset, trigger, clearErrors, formState: { errors, isSubmitting } } = useForm<CustomerFormModel>({
        defaultValues: {
            prefix: "+91",
            countryId: user?.store?.countryId?.toString() ?? "",
            stateId: user?.store?.stateId?.toString() ?? "",
            cityId: user?.store?.cityId?.toString() ?? ""
        },
        mode: 'onBlur'
    });
    const verifyCustomer = async () => {
        try {
            setLoading(true);
            const response: any = await getCustomerByMobileNo(mobileNo);
            if (response.status === 200) {
                notistack.success(response.message);
                handleSelectCustomer(response.data);
                setNewCustomerForm(response?.data)
                if (response.data.countryId)
                    await handleCountryChange(response.data.countryId);
                if (response.data.stateId)
                    await handleStateChange(response.data.stateId);
            }
        } catch (error: any) {
            notistack.error(error.message);
        } finally {
            setLoading(false);
        }
    };
    const onSubmit = async (data: CustomerFormModel, updatedForm?: any) => {
        // Use the updated form if provided, otherwise use the current newCustomerForm
        const finalCustomerForm = updatedForm || newCustomerForm;
        try {
            setLoading(true);
            const payload = {
                ...data,
                walkInSourceId: data?.walkInSourceId ? Number(data.walkInSourceId) || null : null,
                ...(finalCustomerForm?.customerAddressList
                    ? { customerAddressList: finalCustomerForm.customerAddressList }
                    : {}),
            };

            if (!selectedCustomer) {
                const response = await AddCustomerData(payload);
                if (response.status === HttpStatus.Success) {
                    notistack.notifyFromApi(response);
                    const newCustomer: Customer = {
                        id: response.data || response.data?.id,
                        firstName: data.firstName,
                        lastName: data.lastName,
                        mobileNo: data.mobileNo,
                        email: data.email || '',
                        address: data.address || '',
                        zipCode: data.zipcode || '',
                        prefix: data.prefix || '',
                        anniversaryDate: data.anniversary || '',
                        birthdayDate: data.birthday || '',
                        engagementDate: data.engagement || '',
                        partnerName: data.spouseName || '',
                        partnerContactNo: data.spouseContactNo || '',
                        partnerBirthdayDate: data.spouseBirthday || '',
                        gender: data.gender || '',
                        altMobileNo: data.altMobileNo || '',
                        gstNo: data.gstNo || '',
                        panCardNo: data.panCardNo || '',
                        walkInSourceId: data?.walkInSourceId ? Number(data.walkInSourceId) || null : null,
                    };
                    setCustomers(prev => [newCustomer, ...prev]);
                    setSelectedCustomer(newCustomer);
                    verifyCustomer();
                } else {
                    notistack.notifyFromApi(response);
                    await getCustomersData();
                    closeModal();
                    handleCustomerClick(response.data);
                    setSelectedCustomer(null);
                }
            } else {
                if (finalCustomerForm.customerAddressList.some((addr: any) =>
                    addr?.id !== undefined && addr?.id !== null)) {

                    const updatePayload = {
                        ...data,
                        id: selectedCustomer.id,
                        walkInSourceId: data?.walkInSourceId ? Number(data.walkInSourceId) || null : null,
                        ...(finalCustomerForm?.customerAddressList
                            ? { customerAddressList: finalCustomerForm.customerAddressList }
                            : {}),
                    };

                    if (selectedShippingId) {
                        setBillingAddressId(selectedShippingId);
                    }

                    const updateResp = await updateCustomer(updatePayload);
                    if (updateResp.status == 200) {
                        notistack.notifyFromApi(updateResp);
                        verifyCustomer();
                    } else {
                        notistack.notifyFromApi(updateResp);
                        return;
                    }
                } else {
                    toast.error('Please add a valid address');
                }
            }
        } catch (error: any) {
            notistack.notifyFromApi(error.message);
        } finally {
            setLoading(false);
        }
    };


    const getAllCountryDetails = async () => {
        try {
            const response = await getAllCountryForSelect();
            if (response.status === HttpStatus.Success) {
                setCountryData(response?.data);
            }
        } catch (error) {
            console.error("Error fetching country data:", error);
        }
    };

    const handleCountryChange = async (countryId: any) => {
        try {
            const response = await getStateByCountryId(countryId);
            if (response.status === HttpStatus.Success) {
                setStateList(response.data);
                setCityList([]);
            }
        } catch (error) {
            console.log(error);
        }
    };

    const handleStateChange = async (stateId: any) => {
        try {
            const response = await getCityListByStateId(stateId);
            if (response.status === HttpStatus.Success) {
                setCityList(response.data);
            }
        } catch (error) {
            console.log(error);
        }
    };



    const handleShow = async () => {
        try {
            await getAllCountryDetails();
            await getCustomersData();

            if (!customerData) {
                setSelectedCustomer(null);
            }
            setSearchTerm('');
        } catch (error) {
            console.error("Error in handleShow:", error);
        }
    };

    const getWalkins = async () => {
        try {
            const response = await getAllWalkInSourceForSelect()
            if (response.status == HttpStatus.Success) {
                setWalkInSources(response.data)
            }
        } catch (error) {
            // notistack.error(error)
            console.log(error)
        }
    }
    useEffect(() => {
        if (show) {
            handleShow();
            getWalkins();
            if (!selectedCustomer && !customerData) {
                setFocus('mobileNo');
            }
        }
    }, [show]);


    const setStoreLocation = useCallback(async () => {
        if (countryDataList.length > 0 && user?.store) {
            try {
                if (user.store.countryId) {
                    const countryId = user.store.countryId.toString();
                    setValue("countryId", countryId);

                    const statesResponse = await getStateByCountryId(user.store.countryId);
                    if (statesResponse.status === HttpStatus.Success) {
                        setStateList(statesResponse.data);

                        if (user.store.stateId) {
                            const stateId = user.store.stateId.toString();
                            setValue("stateId", stateId);

                            const citiesResponse = await getCityListByStateId(user.store.stateId);
                            if (citiesResponse.status === HttpStatus.Success) {
                                setCityList(citiesResponse.data);
                                if (user.store.cityId) {
                                    setValue("cityId", user.store.cityId.toString());
                                }
                            }
                        }
                    }
                }
            } catch (error) {
                console.error("Error setting store location:", error);
            }
        }
    }, [countryDataList, user?.store, setValue]);

    useEffect(() => {
        const runTwice = async () => {
            await setStoreLocation();
            await setStoreLocation();
        };

        runTwice();
    }, [setStoreLocation]);

    const getCustomersData = async () => {
        try {
            const response = await AddAllCustomerData();
            const mappedCustomers = response.data.map((customer: any) => ({
                zipcode: customer.zipCode,
                anniversary: customer.anniversaryDate,
                birthday: customer.birthdayDate,
                engagement: customer.engagementDate,
                spouseName: customer.partnerName,
                spouseContactNo: customer.partnerContactNo,
                spouseBirthday: customer.partnerBirthdayDate,
                zipCode: customer.zipCode,
                anniversaryDate: customer.anniversaryDate,
                birthdayDate: customer.birthdayDate,
                engagementDate: customer.engagementDate,
                partnerName: customer.partnerName,
                partnerContactNo: customer.partnerContactNo,
                partnerBirthdayDate: customer.partnerBirthdayDate
            }));
            setCustomers(response.data);
            setFilteredCustomers(response.data);

        } catch (error: any) {
            notistack.notifyFromApi(error.message);
        }
    };

    useEffect(() => {
        if (!searchTerm) {
            setFilteredCustomers(customers);
        } else {
            const filtered = customers.filter(customer =>
                customer.firstName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.lastName.toLowerCase().includes(searchTerm.toLowerCase()) ||
                customer.mobileNo.includes(searchTerm) ||
                (customer.email && customer.email.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (customer.city && customer.city.toLowerCase().includes(searchTerm.toLowerCase())) ||
                (customer.state && customer.state.toLowerCase().includes(searchTerm.toLowerCase()))
            );
            setFilteredCustomers(filtered);
        }
    }, [searchTerm, customers]);

    useEffect(() => {
        if (customerData) {
            handleSelectCustomer(customerData);
            setShowCustomersList(true);
        }
    }, [customerData]);

    const handleSelectCustomer = async (customer: Customer) => {
        setSelectedCustomer(customer);
        handleCustomerClick(customer);
        setValue('prefix', customer.prefix || '+91');
        setValue('mobileNo', customer.mobileNo);
        setValue('firstName', customer.firstName);
        setValue('lastName', customer.lastName);
        setValue('email', customer.email || '');
        setValue('anniversary', formatDateForInput(customer.anniversaryDate || customer.anniversary));
        setValue('birthday', formatDateForInput(customer.birthdayDate || customer.birthday));
        setValue('engagement', formatDateForInput(customer.engagementDate || customer.engagement));
        setValue('spouseName', customer.partnerName || customer.spouseName || '');
        setValue('spouseContactNo', customer.partnerContactNo || customer.spouseContactNo || '');
        setValue('spouseBirthday', formatDateForInput(customer.partnerBirthdayDate || customer.spouseBirthday));
        setValue('gender', customer.gender || '');
        setValue('altMobileNo', customer.altMobileNo || '');
        setValue('gstNo', customer.gstNo || '');
        setValue('panCardNo', customer.panCardNo || '');
        setValue('walkInSourceId', customer.walkInSourceId?.toString() || '');
        clearErrors(["mobileNo", "firstName", "lastName"]);
    };

    const handleClearSelection = () => {
        setSelectedCustomer(null);
        setActiveTab("customer");
        setShowCustomersList(false)
        reset()
        setNewCustomerForm(null)
        setValue('prefix', '+91');
        setSelectedBilling(0)
    };

    const [firstName, lastName] = watch([
        "firstName",
        "lastName",
    ]);

    const formatDateForInput = (dateString: string | undefined) => {
        if (!dateString) return '';
        try {
            const date = new Date(dateString);
            return date.toISOString().split('T')[0];
        } catch {
            return '';
        }
    };

    const mobileNo = watch('mobileNo');

    useEffect(() => {
        setNewCustomerForm((prev: any) => ({
            ...prev,
            firstName,
            lastName,
            mobileNo,
        }));
    }, [firstName, lastName, mobileNo]);

    useEffect(() => {
        // verifyCustomer()
        if (mobileNo && /^[0-9]{10}$/.test(mobileNo) && !selectedCustomer?.id) {
            verifyCustomer();
        }
    }, [mobileNo]);

    const validateBirthdate = (value: string): any => {
        if (value) {
            const [year, month, day] = value?.split("-").map(Number);
            const inputDate = new Date(year, month - 1, day);
            const today = new Date();
            inputDate.setHours(0, 0, 0, 0);
            today.setHours(0, 0, 0, 0);
            if (inputDate > today) {
                return "Birthdate cannot be in the future";
            }
            return true;
        }
    };

    const todayStr = new Date().toISOString().split("T")[0];

    return (
        <>
            <Modal
                show={show}
                size='lg'
                onHide={() => {
                    if (newCustomerForm?.mobileNo && newCustomerForm?.firstName && newCustomerForm?.lastName) {
                        if (!Number(selectedBilling)) {
                            notistack.warning("Please select the billing address");
                            return;
                        }
                        setActiveTab("customer");
                        closeModal();
                        handleCustomerClick(selectedCustomer);
                    }
                    else {
                        closeModal();
                    }
                }}
                className="fade"
                dialogClassName="modal-dialog-centered"
                backdrop="static"
            >
                <Modal.Header closeButton className="border-0">
                    <div className="d-flex align-items-center w-100">
                        {selectedCustomer ? (
                            <div className="alert alert-success mb-0 p-2 d-flex align-items-center flex-grow-1">
                                <i
                                    className="bx bx-check-circle me-2 text-success"
                                    style={{ fontSize: "20px" }}
                                ></i>
                                <div>
                                    <div className="mb-1">
                                        <span className="fw-bold text-success">
                                            Currently Selected Customer:{" "}
                                        </span>
                                        <strong>
                                            {(selectedCustomer?.firstName ?? "") +
                                                " " +
                                                (selectedCustomer?.lastName ?? "")}
                                        </strong>
                                        {" - "}
                                        {selectedCustomer?.mobileNo}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            <h5 className="mb-0 fw-bold d-flex align-items-center">
                                <i className="bx bx-user-plus me-2"></i>
                                Add New Customer
                            </h5>
                        )}
                    </div>
                </Modal.Header>

                <hr />
                <Modal.Body style={{ maxHeight: "80vh", overflowY: "auto" }}>
                    <Tabs
                        id="customer-tabs"
                        activeKey={activeTab}
                        onSelect={(k: any) => setActiveTab(k || "customer")}
                        className="mb-3"
                    >
                        <Tab eventKey="customer" title="Customer">
                            <Row>
                                <Col lg={16}>
                                    <Form >
                                        <Form.Group>
                                            <div className="row">
                                                <div className="col-md-4 mb-2 ">
                                                    <Form.Label className='mb-0'>Prefix <span className="text-danger">*</span></Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            disabled
                                                            className="form-control-sm"
                                                            placeholder="+91"
                                                            {...register("prefix", { required: "Prefix is required" })}
                                                        />
                                                    </InputGroup>
                                                    {errors.prefix && <span className="text-danger small">{String(errors.prefix.message)}</span>}
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Mobile No. <span className="text-danger">*</span></Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            maxLength={10}
                                                            type="tel"
                                                            disabled={selectedCustomer ? true : false}
                                                            placeholder="Enter 10-digit mobile number"
                                                            {...register("mobileNo", {
                                                                required: "Mobile number is required",
                                                                pattern: {
                                                                    value: /^[1-9][0-9]{9}$/,
                                                                    message: "Enter a valid 10-digit mobile number",
                                                                },
                                                                validate: {
                                                                    notAllSame: (val) =>
                                                                        /^(\d)\1{9}$/.test(val) ? "Mobile number cannot have all same digits" : true,
                                                                },
                                                            })}
                                                            onChange={(e) => {
                                                                setValue("mobileNo", (e.target.value), { shouldValidate: true });
                                                            }}
                                                            autoComplete="tel-national-abc"
                                                            onKeyDown={(e: any) => {
                                                                const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight", "Tab", "Delete", "Enter"];
                                                                const isCtrl = e.ctrlKey || e.metaKey;
                                                                if (isCtrl && ["c", "v", "x"].includes(e.key.toLowerCase())) {
                                                                    return;
                                                                }
                                                                if (!/[0-9]/.test(e.key) && !allowedKeys.includes(e.key)) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.mobileNo && <span className="text-danger small">{String(errors.mobileNo.message)}</span>}
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>First Name <span className="text-danger">*</span></Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            placeholder="Enter first name"
                                                            maxLength={30}
                                                            {...register("firstName", {
                                                                required: "First name is required",
                                                                pattern: {
                                                                    value: /^[A-Za-z\s]+$/,
                                                                    message: "First Name should contain only letters",
                                                                },

                                                            })}
                                                            autoComplete="tel-national-abc"
                                                            onInput={(e: any) => {
                                                                let value = e.target.value.replace(/\s+/g, ' ');
                                                                if (value.startsWith(' ')) {
                                                                    value = value.trimStart();
                                                                }
                                                                e.target.value = value;
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.firstName && <span className="text-danger small">{String(errors.firstName.message)}</span>}
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Last Name <span className="text-danger">*</span></Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            maxLength={30}
                                                            placeholder="Enter last name"
                                                            {...register("lastName", {
                                                                required: "Last name is required", pattern: {
                                                                    value: /^[A-Za-z\s]+$/,
                                                                    message: "First Name should contain only letters",
                                                                },

                                                            })}
                                                            autoComplete="tel-national-abc"
                                                            onInput={(e: any) => {
                                                                let value = e.target.value.replace(/\s+/g, ' ');
                                                                if (value.startsWith(' ')) {
                                                                    value = value.trimStart();
                                                                }
                                                                e.target.value = value;
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.lastName && <span className="text-danger small">{String(errors.lastName.message)}</span>}
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Email</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            type="email"

                                                            placeholder="Enter email"
                                                            {...register("email", {
                                                                pattern: {
                                                                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                                                                    message: "Enter a valid email address",
                                                                },
                                                            })}
                                                            autoComplete="tel-national-abc"
                                                            onInput={(e: any) => {
                                                                e.target.value = e.target.value.replace(/\s/g, "");
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.email && <span className="text-danger small">{String(errors.email.message)}</span>}
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Anniversary Date</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control type="date" {...register("anniversary")} className="form-control form-control-sm" />
                                                    </InputGroup>
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className="mb-0">Birthday Date</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            max={todayStr}
                                                            {...register("birthday", {
                                                                validate: validateBirthdate,
                                                            })}
                                                        />
                                                    </InputGroup>
                                                    {errors.birthday && <span className="text-danger small">{String(errors.birthday.message)}</span>}
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Engagement Date</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            type="date"
                                                            {...register("engagement")}
                                                        />
                                                    </InputGroup>
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Spouse Name</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            maxLength={30}
                                                            className="form-control-sm"
                                                            placeholder="Enter spouse name"
                                                            {...register("spouseName", {
                                                                pattern: {
                                                                    value: /^[A-Za-z\s]+$/,
                                                                    message: "Only alphabets are allowed",
                                                                },
                                                                minLength: {
                                                                    value: 2,
                                                                    message: "spouse name must be at least 2 characters long"
                                                                },
                                                            }
                                                            )}
                                                            onInput={(e: any) => {
                                                                let value = e.target.value.replace(/\s+/g, ' ');
                                                                if (value.startsWith(' ')) {
                                                                    value = value.trimStart();
                                                                }
                                                                e.target.value = value;
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.spouseName && <span className="text-danger small">{String(errors.spouseName.message)}</span>}
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Spouse Mobile No</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            maxLength={10}
                                                            placeholder="Enter spouse mobile no"
                                                            {...register("spouseContactNo", {
                                                                pattern: {
                                                                    value: /^[1-9][0-9]{9}$/,
                                                                    message: "Enter a valid 10-digit spouse mobile number",
                                                                },
                                                                validate: {
                                                                    notAllSame: (val) =>
                                                                        val && /^(\d)\1{9}$/.test(val)
                                                                            ? "Spouse mobile number cannot have all digits the same"
                                                                            : true,
                                                                },
                                                            })}
                                                            onKeyDown={(e) => {
                                                                if (
                                                                    !/[0-9]/.test(e.key) &&
                                                                    !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
                                                                ) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />

                                                    </InputGroup>
                                                    {errors.spouseContactNo && <span className="text-danger small">{String(errors.spouseContactNo.message)}</span>}
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Spouse Birthday Date</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            type="date"
                                                            className="form-control form-control-sm"
                                                            max={todayStr}
                                                            {...register("spouseBirthday", {
                                                                validate: validateBirthdate,
                                                            })}
                                                        />
                                                    </InputGroup>
                                                    {errors.spouseBirthday && <span className="text-danger small">{String(errors.spouseBirthday.message)}</span>}
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Gender</Form.Label>
                                                    <InputGroup>
                                                        <Form.Select
                                                            {...register("gender")}
                                                            className="form-select-sm"
                                                        >
                                                            <option value="">Select Gender</option>
                                                            <option value="Male">Male</option>
                                                            <option value="Female">Female</option>
                                                            <option value="Other">Other</option>
                                                        </Form.Select>
                                                    </InputGroup>
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>Alt Mobile No</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            maxLength={10}
                                                            placeholder="Enter alt mobile no"
                                                            {...register("altMobileNo", {
                                                                pattern: {
                                                                    value: /^[1-9][0-9]{9}$/,
                                                                    message: "Enter a valid 10-digit mobile number",
                                                                },
                                                                validate: {
                                                                    notAllSame: (val) =>
                                                                        val && /^(\d)\1{9}$/.test(val)
                                                                            ? "Alt mobile number cannot have all digits the same"
                                                                            : true,
                                                                },
                                                            })}
                                                            autoComplete="tel-national-abc"
                                                            onKeyDown={(e) => {
                                                                if (
                                                                    !/[0-9]/.test(e.key) &&
                                                                    !["Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab"].includes(e.key)
                                                                ) {
                                                                    e.preventDefault();
                                                                }
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.altMobileNo && <span className="text-danger small">{String(errors.altMobileNo.message)}</span>}
                                                </div>
                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>GST No</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            placeholder="Enter gst no"

                                                            {...register("gstNo", {
                                                                pattern: {
                                                                    value: /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/,
                                                                    message: "Invalid GST Number format",
                                                                },
                                                            })}
                                                            autoComplete="tel-national-abc"
                                                            onInput={(e: any) => {
                                                                e.target.value = e.target.value.replace(/\s/g, "");
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.gstNo && <span className="text-danger small">{String(errors.gstNo.message)}</span>}
                                                </div>

                                                <div className="col-md-4 mb-2">
                                                    <Form.Label className='mb-0'>PAN Card No</Form.Label>
                                                    <InputGroup>
                                                        <Form.Control
                                                            className="form-control-sm"
                                                            placeholder="Enter pan card no"
                                                            {...register("panCardNo", {
                                                                pattern: {
                                                                    value: /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/,
                                                                    message: "Invalid PAN card format"
                                                                }
                                                            })}
                                                            onInput={(e: any) => {
                                                                e.target.value = e.target.value.replace(/\s/g, "");
                                                            }}
                                                        />
                                                    </InputGroup>
                                                    {errors.panCardNo && <span className="text-danger small">{String(errors.panCardNo.message)}</span>}
                                                </div>
                                                <div className="row mt-1">
                                                    <div className="col-sm-3">
                                                        <Form.Label className='mb-0'>Walk In Source</Form.Label>
                                                        <Form.Select
                                                            className="form-select-sm"
                                                            {...register("walkInSourceId")}
                                                        >
                                                            <option value="">-- WalkIn --</option>
                                                            {walkInSources?.map((c: any) => (
                                                                <option key={c.value} value={c.value}>
                                                                    {c.text}
                                                                </option>
                                                            ))}
                                                        </Form.Select>
                                                        {errors.walkInSourceId && <span className="text-danger small">{String(errors.walkInSourceId.message)}</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </Form.Group>
                                    </Form>
                                </Col>
                            </Row>
                        </Tab>

                        <Tab eventKey="address" title="Address" disabled={!(newCustomerForm?.firstName && newCustomerForm?.lastName && newCustomerForm?.mobileNo)}>
                            <Row>
                                <ShippingAddressModal
                                    closeModal={closeModal}
                                    newCustomerForm={newCustomerForm}
                                    setNewCustomerForm={setNewCustomerForm}
                                    selectedShippingId={selectedShippingId}
                                    setSelectedShippingId={setSelectedShippingId}
                                    customerHasRequiredFields={!!(newCustomerForm?.firstName && newCustomerForm?.lastName && newCustomerForm?.mobileNo)}
                                    currentCustomer={selectedCustomer}
                                    onSubmitCustomer={(updatedForm) => onSubmit(watch(), updatedForm)}
                                    isSubmitting={isSubmitting}
                                    onSelect={setActiveTab}
                                    setSelectedBilling={setSelectedBilling}
                                    selectedBilling={selectedBilling}
                                />
                            </Row>
                        </Tab>
                    </Tabs>

                    <Modal.Footer>
                        {activeTab === "customer" && (
                            <>
                                <button
                                    type="button"
                                    onClick={async () => {
                                        const isValid = await trigger();
                                        if (!isValid) {
                                            toast.error("Please fill required customer details!");
                                            return;
                                        }

                                        if (isValid) {
                                            setActiveTab("address");
                                            await onSubmit(watch(), newCustomerForm);
                                        } else {
                                        }
                                    }}
                                    style={{
                                        backgroundColor: "#3498db",
                                        border: "none",
                                        color: "#fff",
                                        padding: "6px 16px",
                                        borderRadius: "4px",
                                        fontSize: "14px",
                                    }}
                                >
                                    {loading ? "Saving..." : (selectedCustomer ? "Update & Next" : "Save & Next")}
                                </button>
                                {selectedCustomer && activeTab === "customer" && (
                                    <button
                                        type="button"
                                        onClick={handleClearSelection}
                                        style={{
                                            backgroundColor: "#e74c3c",
                                            border: "none",
                                            color: "#fff",
                                            padding: "6px 16px",
                                            borderRadius: "4px",
                                            fontSize: "13px",
                                            marginLeft: "8px",
                                        }}
                                    >
                                        <i className="bx bx-trash me-1"></i>
                                        Remove
                                    </button>
                                )}
                            </>
                        )}
                    </Modal.Footer>
                </Modal.Body>
            </Modal>
        </>
    );
};

export default AddCustomer;